import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const ServiceActive = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 12 13">
      <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_71_89440)">
      <path d="M11 6.03999V6.49999C10.9994 7.57821 10.6502 8.62733 10.0047 9.49091C9.35908 10.3545 8.45164 10.9862 7.41768 11.2919C6.38371 11.5977 5.27863 11.5609 4.26723 11.1873C3.25584 10.8136 2.39233 10.123 1.80548 9.21853C1.21863 8.31401 0.939896 7.24403 1.01084 6.16815C1.08178 5.09228 1.4986 4.06816 2.19914 3.24853C2.89968 2.4289 3.84639 1.85768 4.89809 1.62007C5.9498 1.38245 7.05013 1.49116 8.035 1.92999" stroke="#2E434D" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11 2.5L6 7.505L4.5 6.005" stroke="#2E434D" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
      <clipPath id="clip0_71_89440">
      <rect width="12" height="12" fill="white" transform="translate(0 0.5)"/>
      </clipPath>
      </defs>
      </svg>
   </SvgIcon>
  );
}

export default ServiceActive;